var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('page-header'),_c('router-view',{on:{"show-download-modal":function($event){_vm.sistema = $event}}}),_c('page-footer'),_c('modal-download',{attrs:{"sistema":_vm.sistema},on:{"close":function($event){_vm.sistema = ''}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }